export { Text } from './Text';
export { StyledText } from './Text.styles';

//# sourceMappingURL=index.js.map